export enum GridDisplayType {
  None,
  ShortText,
  LongText,
  Boolean,
  Number,
  PickList,
  DateTime,
  Date,
  Time,
  Duration,
  Trigger,
  QuickList,
  Password,
  Bytes,
  Checkbox,
  Document
}
